import { useContext } from "react"
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Chat() {
  const { data, addVideo, firstAvailablePosition } = useContext(MultiContext)
  const nextPosition = firstAvailablePosition()
  const onClick = ({ uuid }) => {
    const { videoId } = data.find((d) => d.uuid === uuid)
    addVideo(nextPosition, videoId, { chat: true })
  }

  return (
    <Panel>
      <Panel.Heading>
        <Panel.HeadingDescription>
          Open chat for a live-streaming video in the next available position
        </Panel.HeadingDescription>
      </Panel.Heading>
      <Panel.Layout Icon={ChatBubbleLeftRightIcon} onClick={onClick} />
    </Panel>
  )
}
